import script from "./OnePageView.vue?vue&type=script&setup=true&lang=ts"
export * from "./OnePageView.vue?vue&type=script&setup=true&lang=ts"

import "./OnePageView.vue?vue&type=style&index=0&id=194bb107&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-194bb107"]])

export default __exports__